import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function HomeLiving() {
  const [HomeLiving, setHomeLiving] = useState([]);

  useEffect(() => {
    const fetchHomeLiving = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/home/parallel-image-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setHomeLiving(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchHomeLiving();
  }, []);

  return (

    <div
      className="home-living-sec"
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + HomeLiving.bg_image
          })`,
      }}
    >
      <div className="overlay"></div>
      <Container fluid>
        <Row className="banner-text-center">
          <Col md={12}>
            <div className="heading-div">
              <h2 className="common-head whiteColor" data-aos="fade-up">
                {HomeLiving.section_title}
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
    </div>

  );
}

export default HomeLiving;
